const TABBABLE_SELECTOR = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
].join(', ');

/** Return the keyboard-reachable elements inside `root`, in DOM order. */
export const getTabbables = (root) => (root ? [...root.querySelectorAll(TABBABLE_SELECTOR)] : []);

/** Return the first tabbable in the document after `node` that is not inside `exclude`. */
export const getNextTabbableAfter = (node, exclude) =>
    getTabbables(document.body).find(
        (element) =>
            !node.contains(element)
            && !exclude?.contains(element)
            // eslint-disable-next-line no-bitwise
            && node.compareDocumentPosition(element) & Node.DOCUMENT_POSITION_FOLLOWING,
    ) ?? null;

export const isInside = (nodes, target) => nodes.some((node) => node && target instanceof Node && node.contains(target));
